'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

// Periodically re-fetch the server component so the Rider watchlist + positions stay live without a
// manual reload (the crons update the DB every 1–3 min).
export default function AutoRefresh({ seconds = 30 }: { seconds?: number }) {
  const router = useRouter();
  useEffect(() => {
    const id = setInterval(() => router.refresh(), Math.max(10, seconds) * 1000);
    return () => clearInterval(id);
  }, [router, seconds]);
  return null;
}
